import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import FeatureCards from './components/FeatureCards';
import PrivacySection from './components/PrivacySection';
import FAQSection from './components/FAQSection';
import FooterUtilityBar from './components/FooterUtilityBar';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
function AppStoreRedirect() {
  useEffect(() => {
    window.location.href = 'https://apps.apple.com/us/app/emigo-better-texting/id6748092950';
  }, []);
  return null;
}
function HomePage({
  scrollToBottom = false
}: {
  scrollToBottom?: boolean;
}) {
  useEffect(() => {
    if (!scrollToBottom) return;
    // Wait for layout to settle so document.body height is final, then jump.
    const id = window.requestAnimationFrame(() => {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: 'auto'
      });
    });
    return () => window.cancelAnimationFrame(id);
  }, [scrollToBottom]);
  return <>
      <Navbar data-id="element-0" />
      <main className="flex-grow" data-id="element-1">
        <Hero data-id="element-2" />
        <FeatureCards data-id="element-3" />
        <PrivacySection data-id="element-4" />
        <FAQSection data-id="element-5" />
        <FooterUtilityBar data-id="element-6" />
      </main>
    </>;
}
export function App() {
  document.title = 'Emigo — Text with clarity';
  return <BrowserRouter data-id="element-7">
      <div className="flex flex-col min-h-screen w-full" style={{
      backgroundColor: 'var(--cream)'
    }} data-id="element-8">
        <Routes data-id="element-9">
          <Route path="/" element={<HomePage data-id="element-11" />} data-id="element-10" />
          <Route path="/feedback" element={<HomePage scrollToBottom={true} data-id="element-13" />} data-id="element-12" />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-15" />} data-id="element-14" />
          <Route path="/terms-of-service" element={<TermsOfServicePage data-id="element-17" />} data-id="element-16" />
          <Route path="/ig" element={<AppStoreRedirect data-id="element-19" />} data-id="element-18" />
          <Route path="/tiktok" element={<AppStoreRedirect data-id="element-21" />} data-id="element-20" />
        </Routes>
      </div>
    </BrowserRouter>;
}